import { render, staticRenderFns } from "./HeaderConfig.vue?vue&type=template&id=6471c448&scoped=true&"
import script from "./HeaderConfig.vue?vue&type=script&lang=js&"
export * from "./HeaderConfig.vue?vue&type=script&lang=js&"
import style0 from "./HeaderConfig.vue?vue&type=style&index=0&id=6471c448&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6471c448",
  null
  
)

export default component.exports